import { arendalFacts } from "./arendalsuka";

const count = value => value.toLocaleString("en-GB");

// `summary` is the short category label, `place` is where the work is, and `result`
// is the one-line finding shown on the Projects index. Keep the slugs: they are the
// public URLs of the case studies.
const projects = [
  {
    slug: "arendalsuka",
    title: "Arendalsuka",
    summary: "Event mobility",
    place: "Arendal",
    result: `Presence in Arendal's town centre peaked at ${count(arendalFacts.peak)} estimated devices, ${arendalFacts.lift} times the July median.`,
    available: true,
  },
  {
    slug: "may-17th",
    title: "17 May in Oslo",
    summary: "Event readiness",
    place: "Oslo",
    result: "We show how busy each broad zone of central Oslo is through the day: quiet, building, busy or easing.",
    available: true,
  },
  {
    slug: "vaulen-school",
    title: "Vaulen School",
    summary: "School mobility",
    place: "Stavanger",
    result: "An interim move to Sørmarka would take the average modelled walk from 9 to 31 minutes.",
    available: true,
  },
  {
    slug: "frogn-city-development",
    title: "Frogn and Drøbak",
    summary: "Municipal planning",
    place: "Frogn",
    result: "In our retail model, the best site for a new grocery store keeps 29 MNOK a year more spending in Frogn.",
    available: true,
  },
  {
    slug: "road-closure-fornebu",
    title: "E18 lane closure at Fornebu",
    summary: "Road impact forecast",
    place: "Fornebu",
    result: "Our forecast, made before the closure, put the peak queue on the Oslo-bound E18 at 4,675 vehicles.",
    available: true,
  },
];

export default projects;
